import { FC } from 'react'

type Props = {
  fecha: string
}

const LogCeldaFecha: FC<Props> = ({ fecha }) => {
  // Convertir la cadena de texto en formato de fecha
  const date = new Date(fecha);

  // Obtener día, mes y año
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // El mes está basado en 0
  const year = date.getFullYear();

  // Obtener horas y minutos
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  // Construir la cadena con el formato "dd/mm/aaaa hh:mm"
  const formattedDate = `${day}/${month}/${year} ${hours}:${minutes}`;

  return <div className='d-flex justify-content-end'>{formattedDate}</div>;
}

export { LogCeldaFecha }
